import xrpLogo from "@/assets/tokens/xrp.png";

/**
 * XRP mark rendered from a bundled asset. Decoding is forced synchronous and eager so the
 * logo is painted on the first frame after a tab switch instead of fading in late.
 */
export function XrpLogo({ className, alt = "XRP" }: { className?: string; alt?: string }) {
  return (
    <img
      src={xrpLogo}
      alt={alt}
      width={64}
      height={64}
      loading="eager"
      decoding="sync"
      fetchPriority="high"
      draggable={false}
      className={`object-contain brightness-0 invert ${className ?? ""}`}
    />
  );
}

export { xrpLogo };
